export default __webpack_public_path__ + "locales/tr/SingleSignOn.json?hash=61cbed87163024a799e12b8b94edd4f3";